import React from 'preact/compat';
import Anchor from 'react-material-web-components/src/Anchor';
import PropTypes from 'prop-types';

import { List, ListItem, ListItemText } from '../index';

const Item = ({
  url,
  title,
}) => (
  <ListItem>
    <ListItemText>
      <Anchor
        href={url}
        title={title}
      >
        {title}
      </Anchor>
    </ListItemText>
  </ListItem>
);

Item.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
};

Item.defaultProps = {
  url: undefined,
  title: undefined,
};

export {
  Item,
  List,
};
